import React, { useContext, useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import ToastContext from "../Context/toastContext";
import axiosClient from "../Utils/axiosClient";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import toolbar from "../Config/toolbarConfig";
import Datagrid from "../Components/Datagrid";
import editSettings from "../Config/editSettingsConfig";
import {
  ButtonComponent,
  ChipListComponent,
} from "@syncfusion/ej2-react-buttons";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const UserLicencePage = () => {
  const { id } = useParams();
  const [url, setUrl] = useState("");
  const [headerQuery, setHeaderQuery] = useState("");
  const [from, setFrom] = useState("");
  const [user, setUser] = useState("");
  const [status, setStatus] = useState(null);
  const [type, setType] = useState(null);
  const [name, setName] = useState("");

  const { showToast } = useContext(ToastContext);
  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const currentDate = new Date();
  let endDate = new Date();

  useTitle(`${t("Licences")} | Netileti`);

  const fetchLicences = async () => {
    setUrl(`${baseUrl}/licences`);
    setFrom("UserLicence");
    setHeaderQuery(`${id}`);
  };

  const fetchUser = async () => {
    const response = await axiosClient.get(`/users/${id}`);

    if (response.status === 200) {
      setUser(response.data);
    }
  };
  useEffect(() => {
    fetchLicences();
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setStatus(status);
  }, [status]);
  const refreshGrid = () => {
    const gridElement = document.getElementById("adaptivebrowser");
    if (gridElement) {
      const grid = gridElement.ej2_instances[0];
      grid.refresh();
    }
  };
  const onSubmit = async (event) => {
    event.preventDefault();

    const payload = {
      userId: id,
      type,
      name,
      orderTimestamp: Math.floor(currentDate.getTime() / 1000).toString(),
      endTimestamp: Math.floor(
        endDate.setFullYear(currentDate.getFullYear() + 1) / 1000
      ).toString(),
    };
    try {
      const response = await axiosClient.post(`/licences`, payload);

      if (response.status === 200) {
        showToast(`${t("Added successfully!")}`, `${t("Success")}`);
        refreshGrid();
      } else {
        showToast(
          `${t("Error")}: ${response.statusText}, ${t("Status Code")}: ${
            response.status
          }`,
          `${t("Error")}`
        );
      }
    } catch (error) {
      showToast(`${t("Failed to add")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const types = [
    { text: t("AccountLicence"), value: 0 },
    { text: t("WhatsappLicence"), value: 1 },
    { text: t("SmsLicence"), value: 2 },
    { text: t("Other"), value: 3 },
  ];
  const typeParams = {
    params: {
      fields: { text: "text", value: "value" },
      sortOrder: "none",
    },
  };
  
  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "userId",
      headerText: "userId",
      allowEditing: false,
      isPrimaryKey: false,
      visible: false,
    },
    {
      field: "type",
      headerText: t("Type"),
      allowEditing: true,
      editType: "dropdownedit",
      edit: typeParams,
      template: (props) => {
        return types[props.type].text || t("Unknown");
      },
      filterTemplate: () => (
        <ComboBoxComponent
          dataSource={types}
          fields={{ text: "text", value: "text" }}
          change={(e) => {
            const selectedValue = e.value;
            const gridElement = document.getElementById("adaptivebrowser");
            if (gridElement) {
              const grid = gridElement.ej2_instances[0];

              if (grid) {
                if (selectedValue) {
                  grid.filterByColumn("type", "equal", selectedValue);
                } else {
                  grid.removeFilteredColsByField("type");
                }
              }
            }
          }}
        />
      ),
    },
    {
      field: "name",
      headerText: t("Name"),
      allowEditing: true,
    },
    {
      field: "orderTimestamp",
      headerText: t("OrderTimestamp"),
      allowEditing: true,
    },
    {
      field: "endTimestamp",
      headerText: t("EndTimestamp"),
      allowEditing: true,
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      <div className="user-licences">
        <div className="e-card e-card-vertical">
          {user.email}
          <ChipListComponent cssClass="e-info">{user.role}</ChipListComponent>
        </div>
        <div className="add-licence">
          <form id="add-licence-form" onSubmit={onSubmit}>
            <ComboBoxComponent
              id="code"
              dataSource={[
                { text: t("AccountLicence"), value: 0 },
                { text: t("WhatsappLicence"), value: 1 },
                { text: t("SmsLicence"), value: 2 },
                { text: t("Other"), value: 3 },
              ]}
              fields={{ text: "text", value: "value" }}
              className="e-input"
              placeholder={t("Type")}
              value={type}
              onChange={(e) => {
                setType(e.target.value);
              }}
              required
            />
            <input
              id="name"
              className="e-input"
              placeholder={t("Name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <ButtonComponent cssClass="e-primary e-outline" type="submit">
              {t("Add Licence")}
            </ButtonComponent>
          </form>
        </div>
        <hr />
        <div className="licence-grid">
          {status === 401 ? (
            <UnauthorizePage />
          ) : status === 403 ? (
            <ForbiddenPage />
          ) : (
            <DatagridContext.Provider
              value={{
                toolbar: toolbar("RUD-EXPORT"),
                editSettings,
                url,
                from,
                headerQuery,
                setStatus,
              }}
            >
              <Datagrid columns={columns} />
            </DatagridContext.Provider>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLicencePage;
